import { gameStore, userStore } from '../stores';
import { IPagination } from '../interfaces/core';
import { IHistoryItem } from '../interfaces/bet';

class BetApiService {

  getBets = async (page: number, pageSize: number): Promise<IPagination<IHistoryItem> | null> => {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/Bets?PageSize=${pageSize}&Page=${page}&GameId=${gameStore.gameId}`, {
      headers: {
        'Authorization': `Bearer ${userStore.accessToken}`,
      }
    });
    if (response.ok) {
      const responseData = await response.json();
      return responseData.data;
    }

    return null;
  }

}

export const betApiService = new BetApiService();
